import { addCpfMask, addZipCodeMask } from '@repo/ui';
import { GetPersonByIdV2UseCaseInterface } from 'domain/usecases';

const personFormInitialValues = (
  person: GetPersonByIdV2UseCaseInterface.Result,
) => ({
  cpf: addCpfMask(person?.cpf) || '',
  name: person?.name || '',
  socialName: person?.socialName || '',
  rg: person?.rg || '',
  birth: person?.dateOfBirth?.substring(0, 10) || '',
  gender: person?.gender?.id
    ? {
        value: person?.gender?.id,
        label: person?.gender?.name,
      }
    : null,
  phone: person?.phone ? `${'+55' + person?.phone}` : '',
  email: person?.email || '',

  zipcode: addZipCodeMask(person?.address?.zipCode) || '',
  street: person?.address?.street || '',
  addressNumber: person?.address?.number || '',
  addressComplement: person?.address?.complement || '',
  district: person?.address?.neighborhood || '',
  city: person?.address?.city
    ? {
        value: person?.address?.city?.id,
        label: person?.address?.city?.name,
      }
    : null,
});

export { personFormInitialValues };
